export default new class Confirm {
    constructor() {
        this.sConfirmClass = '_confirm';
        this.sCreateOrderButtonClass = '_create_order_button';

        this.change();
    }

    change() {
        $(document).on('change', `.${this.sConfirmClass}`, (obEvent) => {
            const obCheckbox = $(obEvent.target);
            const obButton = $(`.${this.sCreateOrderButtonClass}`);

            if (obCheckbox.is(':checked')) {
                obButton.removeAttr('disabled');
            } else {
                obButton.attr('disabled', 'disabled');
            }
        });
    }
}();
